import { render, staticRenderFns } from "./DialyBook.vue?vue&type=template&id=ce992f60&scoped=true"
import script from "./DialyBook.vue?vue&type=script&lang=js"
export * from "./DialyBook.vue?vue&type=script&lang=js"
import style0 from "./DialyBook.vue?vue&type=style&index=0&id=ce992f60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce992f60",
  null
  
)

export default component.exports